class DrawerProduct extends HTMLElement {
  constructor() {
    "use strict";
    super();

    this.drawer = this
    this.selectors = {
      placeContentIn: '[data-ajax-content]',

      variantsJson: '[data-variant-json]',
      currentVariantJson: '[data-current-variant-json]',
      form: '.product-single__form',
      klaviyoForm: '.vdrawer__klaviyo',
      delayedKlaviyoTrigger: '.delayed-klaviyo-bis-trigger',
      klaviyoTrigger: '.vdrawer__klaviyo .btn btn--full klaviyo-bis-trigger',
  
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
  
      originalSelectorId: '[data-product-select]',
      singleOptionSelector: '[data-variant-input]',
      variantColorSwatch: '.variant__input--color-swatch',
    }
    this.container = this.drawer.querySelector('[data-ajax-content]');
    this.addEventListener('VariantDrawer:populate', this.fetchProductViewByHandle);
    
  };
  
  async fetchProductViewByHandle(evt) {
    try {
      const handle = evt.detail.handle;
      if (!handle) {
        console.error('Invalid or missing handle');
        return false;
      };
      
      const url = `${theme.routes.home}products/${handle}?view=ajax` ;
      const res = await fetch(url);
      const text = await res.text();

      this.container.innerHTML = text;
      var sectionId = this.container.querySelector('.vdrawer__product').getAttribute('data-section-id');

      this.settings = {
        namespace: '.product-' + sectionId
      }

      this.formSetup();
      var selected_variant = document.querySelector('.main-content .variant-wrapper .variant-input-button input[type=radio]:checked').value;
      this.container.querySelector('.vdrawer__selectors .variant-input[data-value="'+ selected_variant + '"] input').checked = true;
      this.container.querySelector('.vdrawer__selectors .variant-input input').dispatchEvent(new Event("change"))

      theme.VariantDrawer.open();
    } catch(err) {
      console.error(err)
    }
    this.initDelayedKlaviyoTriggers(); // Call this method here to ensure triggers are initialized after content load

  }

  formSetup() {
    this.initAjaxProductForm();
    this.initVariants();
  }


  initVariants() {
    var variantJson = this.container.querySelector(this.selectors.variantsJson);

    if (!variantJson) {
      return;
    }

    this.variantsObject = JSON.parse(variantJson.innerHTML);

    var options = {
      container: this.container,
      enableHistoryState: false,
      singleOptionSelector: this.selectors.singleOptionSelector,
      originalSelectorId: this.selectors.originalSelectorId,
      variants: this.variantsObject
    }

    this.variants = new theme.Variants(options);
    this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
   

    if (theme.settings.dynamicVariantsEnable) {
      var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

      if (currentVariantJson) {
        var variantType = this.container.querySelector(selectors.variantType);

        if (variantType) {
          console.log("variantType", variantType)
          new theme.VariantAvailability({
            container: this.container,
            namespace: this.settings.namespace,
            type: variantType.dataset.type,
            variantsObject: this.variantsObject,
            currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
          });
        }
      }
    }
    

  }


  setVariantMessages() {
    
  }

  initAjaxProductForm() {
    if (theme.settings.cartType === 'drawer') {
      new theme.AjaxProduct(this.container.querySelector(this.selectors.form));
    }
  }
  
  updateCartButton(evt) {
    var variant = evt.detail.variant;
    var cartBtn = this.container.querySelector(this.selectors.addToCart);
    var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
    var klaviyoForm = this.container.querySelector(this.selectors.klaviyoForm);
    var delayedKlaviyoTrigger = this.container.querySelector(this.selectors.delayedKlaviyoTrigger);
    var klaviyoTrigger = this.container.querySelector(this.selectors.klaviyoTrigger);

    var classes = {
      disabled: 'disabled',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      visuallyHide: 'visually-invisible'
    };

    if (variant) {
      if (variant.available) {
        // Available, enable the submit button and change text
        klaviyoForm.classList.add(classes.hidden);
        cartBtn.classList.remove(classes.hidden);
        cartBtn.classList.remove(classes.disabled);
        cartBtn.removeAttribute('data-select-variant');
        cartBtn.disabled = false;
        var defaultText = cartBtnText.dataset.defaultText;
        cartBtnText.textContent = defaultText;
      } else {
        // Sold out, disable the submit button and change text
        cartBtn.disabled = true;
        cartBtnText.textContent = theme.strings.soldOut
        cartBtn.classList.add(classes.disabled);
        if (theme.settings.klaviyo && theme.settings.klaviyo !== '') {
          klaviyoForm.classList.remove(classes.hidden);
          cartBtn.classList.add(classes.hidden);
        } else {
          klaviyoForm.classList.add(classes.hidden);
          cartBtn.classList.remove(classes.hidden);
        }
      }
    } else {
      // The variant doesn't exist, disable submit button
      klaviyoForm.classList.add(classes.hidden);
      cartBtn.classList.remove(classes.hidden);
      cartBtn.classList.add(classes.disabled);
      cartBtn.disabled = true;
      cartBtnText.textContent = theme.strings.unavailable;
    }

  }


  initDelayedKlaviyoTriggers() {
    const delayedTriggers = this.container.querySelectorAll(this.selectors.delayedKlaviyoTrigger);
    delayedTriggers.forEach(trigger => {
      trigger.addEventListener('click', e => {
        setTimeout(() => {
          // Here, implement the logic to show the Klaviyo BIS form.
          // This might involve simulating a click on the actual Klaviyo trigger,
          // or directly invoking the Klaviyo form display function if available.
          console.log('Triggering Klaviyo BIS form...');
          const klaviyoTrigger = this.container.querySelector('.klaviyo-bis-trigger');
          if (klaviyoTrigger) {
            klaviyoTrigger.click(); // Programmatically click the Klaviyo BIS trigger
          }
          // Example: triggerKlaviyoForm();
        }, 500); // Delay in milliseconds
      });
    });
  }
}

document.addEventListener("page:loaded", () => {
  initEverything();
});

document.addEventListener("collection:reloaded", () => {
  initEverything();
});

document.addEventListener("cart:refresh", () => {
  initEverything(true);
});



const initEverything = (initButtonsOnly = false) => {

  const drawerEl = document.getElementById('VariantDrawer');
  /**
   * 
   * @param {string} handle - Shopify product handle. https://shopify.dev/api/liquid/basics/handle
   */
  const triggerDrawerOpening = (handle) => {
    const evt = new CustomEvent('VariantDrawer:populate', {
      detail: {
        handle: handle
      }
    });
    drawerEl.dispatchEvent(evt);
  };

  const drawerTriggerButtons = document.querySelectorAll(
    "[data-select-variant]"
  );

  drawerTriggerButtons.forEach((btn) => {
    const handle = btn.getAttribute("data-select-variant");
    if (!handle) return;
    btn.addEventListener("click", (evt) => {
      evt.preventDefault();
      triggerDrawerOpening(handle);
 
    });
  });

  if (initButtonsOnly) {
    return;
  }

  if (!theme.VariantDrawer) {
    theme.VariantDrawer = (function() {
      var selectors = {
        drawer: '#VariantDrawer'
      };

      function VariantDrawer() {
        this.drawer = new theme.Drawers('VariantDrawer', 'variant');
        this.init();
      }
    
      VariantDrawer.prototype = Object.assign({}, VariantDrawer.prototype, {
        init: function() {
          document.addEventListener('ajaxProduct:added', this.closeButVisuallyOnly.bind(this));
          document.addEventListener('VariantDrawer:open', this.open.bind(this));
          document.addEventListener('VariantDrawer:close', this.close.bind(this));
        },
    
        open: function() {
          this.drawer.open();
        },
    
        close: function() {
          this.drawer.close();
        },

        closeButVisuallyOnly: function() {
          this.drawer.close(false, true)
          /*
          drawerEl.classList.remove('is-transitioning')
          drawerEl.classList.remove('drawer--is-open')
          */
        }
      });
    
      return VariantDrawer;
    })();

    theme.VariantDrawer = new theme.VariantDrawer();
  }
};

if (customElements.get("drawer-product") === undefined) {
  customElements.define("drawer-product", DrawerProduct);
}
